import React from 'react';
import { useState, useEffect } from 'react';
import {css} from '@emotion/react';
import { Link as LinkScroll } from 'react-scroll';

export default function AnclasInicio({styleCss}) {
  const anclasCss = css`
    position: fixed;
    right: 0;
    top: calc(100vw * (calc(70 / var(--width_base))));
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;

    &.only-desk{
      @media (max-width: 767px){
        display: none;
      }
    }
    & .anclas__link{
      color: #DEDEDE;
      font-size: calc(100vw * (calc(12 / var(--width_base))));
      font-style: italic;
      padding:
              calc(100vw * (calc(8 / var(--width_base))))
              calc(100vw * (calc(35 / var(--width_base))));
      background-color: black;
      position: relative;
    }

    & .anclas__item:not(:last-of-type) .anclas__link{
      &:after{
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        border-right: calc(100vw * (calc(1 / var(--width_base)))) solid #DEDEDE;
        height: calc(100vw * (calc(15 / var(--width_base))));
        margin-top: auto;
        margin-bottom: auto;
      }
    }
    ${styleCss}
  `;


  const [anclaPortada, setAnclaPortada] = useState(false);
  const [anclaContenido, setAnclaContenido] = useState(false);
  const [anclaFicha, setAnclaFicha] = useState(false);
  const [anclaMapa, setAnclaMapa] = useState(false);

  useEffect(()=>{
    if(document.querySelector('div[name="portada"]'))
      setAnclaPortada(true);
    if(document.querySelector('div[name="contenido"]'))
      setAnclaContenido(true);
    if(document.querySelector('div[name="ficha"]'))
      setAnclaFicha(true);
    if(document.querySelector('div[name="mapa"]'))
      setAnclaMapa(true);
  },[])


  return (
    <ul css={anclasCss} className="only-desk">
      {
        anclaPortada && <li className="anclas__item"><LinkScroll className="anclas__link" to="portada" spy={true} smooth={true} duration={500} offset={(typeof window !== `undefined`) && window.innerWidth * (-90 / 1920)}>Contacto</LinkScroll></li>
      }
      {
        anclaContenido && <li className="anclas__item"><LinkScroll className="anclas__link" to="contenido" spy={true} smooth={true} duration={500} offset={(typeof window !== `undefined`) && window.innerWidth * (-140 / 1920)}>El proyecto</LinkScroll></li>
      }
      {
        anclaFicha && <li className="anclas__item"><LinkScroll className="anclas__link" to="ficha" spy={true} smooth={true} duration={500} offset={(typeof window !== `undefined`) && window.innerWidth * (-140 / 1920)}>Ficha técnica</LinkScroll></li>
      }
      {
        anclaMapa && <li className="anclas__item"><LinkScroll className="anclas__link" to="mapa" spy={true} smooth={true} duration={500} offset={(typeof window !== `undefined`) && window.innerWidth * (-70 / 1920)}>Ubicación</LinkScroll></li>
      }
    </ul>
  );

}
